export const PRODUCTS_FETCHED = 'PRODUCTS_FETCHED';
